import { type User, UserManager, WebStorageStateStore } from 'oidc-client-ts';

/**
 * OIDC-клиент сервиса аккредитации. Конфигурация повторяет lk-web/quotas-web —
 * единый стиль логина для всех приложений платформы (Authorization Code + PKCE).
 */
const userManager = new UserManager({
  authority: `${import.meta.env.VITE_KEYCLOAK_URL}/realms/${import.meta.env.VITE_KEYCLOAK_REALM}`,
  client_id: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
  redirect_uri: `${window.location.origin}/auth/callback`,
  // Возвращаемся на /login (путь), чтобы надёжно матчиться под wildcard
  // `http://localhost:5176/*` в Keycloak. Голый origin без пути часто не матчится.
  post_logout_redirect_uri: `${window.location.origin}/login`,
  response_type: 'code',
  scope: 'openid profile email',
  loadUserInfo: true,
  automaticSilentRenew: true,
  silent_redirect_uri: `${window.location.origin}/auth/silent-renew.html`,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
});

export { userManager };
export type { User };

export function startLogin(returnTo?: string): Promise<void> {
  return userManager.signinRedirect({
    state: returnTo ? { returnTo } : undefined,
  });
}

export async function completeLogin(): Promise<{ user: User; returnTo: string }> {
  const user = await userManager.signinRedirectCallback();
  const state = user.state as { returnTo?: string } | undefined;
  return { user, returnTo: state?.returnTo ?? '/' };
}

export function startLogout(): Promise<void> {
  return userManager.signoutRedirect();
}

export function getStoredUser(): Promise<User | null> {
  return userManager.getUser();
}
